module.exports = __webpack_public_path__ + "media/assets/fonts/Helvetica-Regular-06113bf748ae7dc33e05189a90815625.ttf";